import routes from '@/modules/issued-document/issued-document-routes';
import store from '@/modules/issued-document/issued-document-store';

export default {
    routes,
    store,
}
